/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useParams} from 'react-router-dom'
import {useThemeMode} from '../../../../_metronic/partials'
import firebase from '../../../firebase/FirebaseConfig'
import {useUser} from '../../../modules/newauth/UserContext'
import {useNavigate} from 'react-router-dom'
import {VBoxShowScript} from './component/VBoxShowScript'

const VBox = () => {
  const db = firebase.firestore()
  const {mode} = useThemeMode()
  const deviceId = useParams().deviceId
  const {user} = useUser()
  const navigate = useNavigate()

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>V-Box</span>
          </h3>
        </div>

        <div className='card-body border-top py-3'>
          <div className='mb-10'>
            <h5 className='fw-bold mb-3'>Create parameter from V-Box by import .xlsx</h5>
            <Link
              to={`/create-new-parameter-vbox-import/${deviceId}`}
              className='btn btn-primary btn-sm'
            >
              <i className='fas fa-plus fs-5 me-2'></i>Create new parameter by import .xlsx
            </Link>
          </div>

          <div className='separator border-2 my-3'></div>

          <div className='mb-10'>
            <VBoxShowScript />
          </div>
        </div>
      </div>
    </>
  )
}

export {VBox}
